<!-- eslint-disable @angular-eslint/template/no-autofocus -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!--
 // -----------------------------------------------------------------------------
 // <copyright file="form-input.component.html" company="ecoInsight, Inc.">
 // Copyright © ecoInsight, Inc. All rights reserved.
 // </copyright>
 // ------------------------------------------------------------------------------
-->

<div class="justify-content-center float-label">
  <div class="{{ isRequired() ? 'required' : '' }}">
    @switch (errorObj().type) { @case ('') { @if (showLabel() && !error() && !errorMessage()) {
    <label class="{{ isActive() ? 'active' : '' }}"
      >{{ placeHolder() | currency }}{{ errorObj().type }}</label
    >
    } } @case ('required') { @if (showLabel()) {
    <label class="error"
      >{{ placeHolder() | currency }} {{ 'Validation.errMsg.required' | translate }}</label
    >
    } } @case ('precision') { @if (showLabel()) {
    <label class="error">{{ 'v.pr' | translate }}</label>
    } } @case ('invalidValue') { @if (showLabel()) {
    <label class="error">{{ 'v.inm' | translate }}</label>
    } } @case ('mailFormat') { @if (showLabel()) {
    <label class="error">{{ 'Validation.errMsg.email' | translate }}</label>
    } }
    <!-- @case ('minlength') {
        <label class="error">
          @if (!customErrorMsg().min) {
            <ng-container
              >{{ placeHolder() | currency }} {{ 'Validation.errMsg.minLength' | translate }}
              {{ errorObj()['minlength']?.['requiredLength'] }}
              {{ 'Validation.errMsg.minLength1' | translate }}</ng-container
            >
          }
          @if (customErrorMsg().min) {
            {{ customErrorMsg().min | translate }}
          }
        </label>
      }
      @case ('mailFormat') {
        <label class="error">{{ 'Validation.errMsg.email' | translate }}</label>
      }
      @case ('min') {
        <label class="error"
          >{{ placeHolder() | currency }} {{ 'Validation.errMsg.min' | translate
          }}{{ errorObj()['min']?.['min'] }}</label
        >
      }
      @case ('maxlength') {
        <label class="error">
          @if (!customErrorMsg().max) {
            <ng-container>
              Only {{ errorObj()['maxlength']?.['requiredLength'] }}
              {{ 'Validation.errMsg.maxlength' | translate }}
            </ng-container>
          }
          @if (customErrorMsg().max) {
            {{ customErrorMsg().max | translate }}
          }
        </label>
      }
      @case ('max') {
        <label class="error"
          >{{ placeHolder() | currency }} {{ 'Validation.errMsg.max' | translate
          }}{{ errorObj()['max']?.['max'] }}</label
        >
      }
      @case ('precision') {
        <label class="error"
          >{{ errorObj()['precision']?.['precision'] }}
          {{ 'Validation.errMsg.precision' | translate }}</label
        >
      }
      @case ('strong') {
        <label class="error"
          >{{ errorObj()['strong']?.['strong'] }} {{ 'Validation.errMsg.pp' | translate }}</label
        >
      }
      @case ('specialChar') {
        <label class="error"> {{ 'Validation.errMsg.sp' | translate }}</label>
      }
      @case ('uppercase') {
        <label class="error"> {{ 'Validation.errMsg.uc' | translate }}</label>
      }
      @case ('lowercase') {
        <label class="error"> {{ 'Validation.errMsg.lc' | translate }}</label>
      }
      @case ('number') {
        <label class="error"> {{ 'Validation.errMsg.num' | translate }}</label>
      }
      @case ('invalidValue') {
        <label class="error">{{ 'Validation.errMsg.invalid' | translate }}</label>
      } -->
    }
    <!-- @if (error() && errorMessage()) {
      <label class="error">{{ errorMessage() }}</label>
    } -->
    @if (showPasswordIcon() && !showPwdText()) {
    <i class="i-eye-view" tabindex="0" role="button" (click)="showText(true)"></i>
    } @if (showPasswordIcon() && showPwdText()) {
    <i class="i-not-eye-view" tabindex="0" role="button" (click)="showText(false)"></i>
    } @if (inputType() !== 'textarea') {
    <input
      [attr.id]="id()"
      [attr.autofocus]="af() === true ? true : false"
      tabindex="{{ tabindex() }}"
      [attr.maxLength]="maxLength() ? maxLength() : null"
      type="{{ inputType() }}"
      step="any"
      placeholder="{{ placeHolder() | currency }}"
      (blur)="offFocus($event)"
      class="form-control {{ isActive() ? 'active' : '' }} {{
        errorObj().type || errorMessage() ? 'error' : ''
      }}"
      [formControl]="control()"
      (keypress)="keypress($event)"
      (keyup)="keyup($event)"
      (keydown)="keydown($event)"
      [readonly]="isReadonly()"
      (focus)="focus()"
      autocomplete="off"
      aria-autocomplete="none"
      spellcheck="false"
      [attr.data-testid]="dataTestId()"
    />
    } @if (inputType() === 'textarea') {
    <textarea
      [attr.id]="id()"
      [attr.autofocus]="af() === true ? true : false"
      tabindex="{{ tabindex() }}"
      [attr.maxLength]="maxLength() ? maxLength() : null"
      step="any"
      placeholder="{{ placeHolder() | currency }}"
      (blur)="offFocus($event)"
      class="form-control {{ isActive() ? 'active' : '' }} {{
        errorObj().type || errorMessage() ? 'error' : ''
      }}"
      [formControl]="control()"
      (keyup)="keyup($event)"
      (keydown)="keydown($event)"
      [readonly]="isReadonly()"
      (focus)="focus()"
      autocomplete="no-fill"
      spellcheck="false"
      [attr.data-testid]="dataTestId()"
    ></textarea>
    } @if (control() && !control()!.valid) {
    <span [ngClass]="{ 'i-oval-s': !requiredFlag() ? false : true }"></span>
    }
  </div>
</div>
